import { render, staticRenderFns } from "./StatisticsSettingsDataSet.vue?vue&type=template&id=302a349c&scoped=true"
import script from "./StatisticsSettingsDataSet.vue?vue&type=script&lang=js"
export * from "./StatisticsSettingsDataSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a349c",
  null
  
)

export default component.exports